import { render, staticRenderFns } from "./UICreatePost.vue?vue&type=template&id=fc22d25e"
import script from "./UICreatePost.vue?vue&type=script&lang=js"
export * from "./UICreatePost.vue?vue&type=script&lang=js"
import style0 from "./UICreatePost.vue?vue&type=style&index=0&id=fc22d25e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default,Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default,ImageCropper: require('/skade-pwa/components/ui/atom/ImageCropper.vue').default})
